export enum SystemSettingType {
    InternalExchangeRate = 1,
}
